import React, { Component } from "react";
import "./App.css";

export class PresentationCard extends Component {
  render() {
    return <div className="PresentationCard">{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/PresentationCard.jsx